<template>
  <a-trigger
    class="custom-trigger"
    :trigger="['click']"
    position="bl"
    :popup-offset="8"
    :unmount-on-close="true"
    update-at-scroll
    v-bind="$attrs">
    <template v-for="(value, name) in $slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData || {}"></slot>
    </template>
  </a-trigger>
</template>
